import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/device-replace-v3-activity.png'


const _withScopeId = n => (_pushScopeId("data-v-8533b2c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "main-img",
    src: _imports_0,
    alt: "以旧换新三期"
  })
], -1))

import AppHeader from '@/components/Header.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'activity-notification',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "关于开展极飞农业无人飞机优惠活动的通知" }),
    _hoisted_1
  ], 64))
}
}

})